export default __webpack_public_path__ + "static/media/10.b9585f4b.webp";